import { render, staticRenderFns } from "./RenewalRejection.vue?vue&type=template&id=5a478e0f&scoped=true"
import script from "./RenewalRejection.vue?vue&type=script&lang=js"
export * from "./RenewalRejection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a478e0f",
  null
  
)

export default component.exports